export function evaluatePasswordStrength(
  value: string,
  specialCharRegex: RegExp,
  spaceRegex: RegExp,
): { isStrong: boolean; hasDisallowedChars: boolean } {
  const foundSpecialChar = value.match(specialCharRegex);
  const foundNum = value.match(/[0-9]/g);
  const foundUppercase = value.match(/[A-Z]/g);
  const lowerCase = value.match(/[a-z]/g);
  const isSpace = value.match(spaceRegex);
  const hasDisallowedChars = Boolean(isSpace?.length);
  const isStrong = Boolean(
    value?.length > 8 &&
      foundUppercase?.length &&
      foundSpecialChar?.length &&
      foundNum?.length &&
      lowerCase?.length &&
      !hasDisallowedChars,
  );
  return { isStrong, hasDisallowedChars };
}
